module.exports = __webpack_public_path__ + "static/media/add_users.22795164.svg";